import { LegalLayout, usePublicSettings } from "./LegalLayout";

export default function PolitiqueConfidentialite() {
  const settings = usePublicSettings();
  return (
    <LegalLayout title="Politique de confidentialité" testid="politique-confidentialite-page">
      <section>
        <h2>Responsable du traitement</h2>
        <p>
          MARY SERVICES — SAS, La Valentinière, 61210 Giel-Courteilles — SIREN 919 479 261, représentée par
          Julien MARY, est responsable du traitement des données personnelles collectées sur ce site.
        </p>
      </section>

      <section>
        <h2>Données collectées</h2>
        <p>Via le formulaire de demande de devis, nous collectons uniquement :</p>
        <ul>
          <li>Nom et prénom</li>
          <li>Numéro de téléphone</li>
          <li>Adresse e-mail</li>
          <li>Statut (particulier / professionnel) et type de besoin</li>
          <li>Votre message et, si vous le souhaitez, des photos de votre chantier</li>
        </ul>
      </section>

      <section>
        <h2>Finalité et base légale</h2>
        <p>
          Ces données sont utilisées exclusivement pour répondre à votre demande de devis et assurer le suivi de
          la relation commerciale qui peut en découler (mesures précontractuelles, article 6.1.b du RGPD). Elles ne
          font l'objet d'aucune prospection, d'aucune revente et d'aucun transfert à des tiers à des fins
          commerciales.
        </p>
      </section>

      <section>
        <h2>Durée de conservation</h2>
        <p>
          Les demandes de devis sont conservées au maximum 3 ans à compter du dernier contact, puis supprimées ou
          anonymisées.
        </p>
      </section>

      <section>
        <h2>Vos droits</h2>
        <p>
          Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de
          rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Pour exercer
          ces droits, contactez-nous à{" "}
          <a className="text-forest underline underline-offset-2" href={`mailto:${settings.email}`}>{settings.email}</a>
          {" "}ou par téléphone au {settings.phone}.
        </p>
        <p>
          Vous pouvez également introduire une réclamation auprès de la CNIL (cnil.fr) si vous estimez que vos
          droits ne sont pas respectés.
        </p>
      </section>

      <section>
        <h2>Cookies</h2>
        <p>
          Ce site n'utilise aucun cookie publicitaire ou de suivi. Seules des données techniques strictement
          nécessaires au fonctionnement du site peuvent être stockées localement sur votre appareil.
        </p>
      </section>

      <section>
        <h2>Sécurité</h2>
        <p>
          Les photos et informations transmises sont stockées de manière sécurisée et ne sont accessibles qu'aux
          personnes habilitées de MARY SERVICES.
        </p>
      </section>
    </LegalLayout>
  );
}
